module.exports = __webpack_public_path__ + "img/d14.3ec9641c.jpg";